export default function NoData({ txt = "데이터가 없습니다." }: { txt?: string }) {
    return <div className="py-[50px] text-center text-[#999]">{txt}</div>;
}
